import { ORGANIZATION_TABLE_PAGE_SIZE } from '@/features/tenant-manager/organization/_utils/constants';
import { useDebouncedQueryStates } from '@/lib/nuqs';
import { parseAsInteger } from 'nuqs';

export const useOrganizationsSnapshotQueryState = () => {
  return useDebouncedQueryStates({
    keyMap: {
      page: parseAsInteger.withDefault(1),
      pageSize: parseAsInteger.withDefault(ORGANIZATION_TABLE_PAGE_SIZE),
    },
  });
};
